import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OrdersUpdateProgressType} from "../interface";
import {updateOrderProgress} from "../../../../../api/order/OrdersApi";

export const useUpdateOrderProgress = ({closeCallback}: { closeCallback: () => any }) => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: OrdersUpdateProgressType[]) => updateOrderProgress(data),
        onSuccess: (res) => {
            const data = res.data
            if (data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "수정되었습니다.",
                    type: "alert",
                    closeAction: () => closeCallback()
                });
            } else {
                handleModal({
                    isOpen: true,
                    contents: data.msg,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
